module.exports = __webpack_public_path__ + "img/role_sad.9faa74c8.png";